import { type MCPServerInfo } from '../../types';

const NeonServer: MCPServerInfo = {
  serverId: 'NEON',
  name: 'Neon',
  slug: 'neon',
  description:
    'MCP server for interacting with Neon Management API and databases.',
  source: {
    sourceType: 'REMOTE_URL',
    mcpServerUrl: 'https://mcp.neon.tech/mcp'
  },
  authenticationType: 'OAUTH',
  serverConfig: {
    required: [],
    properties: {}
  },
  installConfig: {
    required: [],
    properties: {}
  }
};

export default NeonServer;
